<template>
    <div class="order-header">
      <h1>{{ title }}</h1>
      <div class='myadress'>
        <div class="f22 grey9">我的地址</div>
        <div class='new_adr' @click="selectAddr">{{name}}{{chosen.mobile?'&nbsp;&nbsp;'+chosen.mobile:''}}<img src="/images/public/white_row.png" alt=""/></div>
      </div>
      <div class='adr_content'>
        <div class="address">
          <div>{{chosen.province}}  {{chosen.city}}  {{chosen.district}}  {{chosen.address}}</div>
          <!-- <div>{{chosen.contacts}} {{chosen.mobile}}</div> -->
        </div>
        <!-- <div class="icon">
          <i></i>
        </div> -->
      </div>
      <div class="express">
        <span class="f22 grey9"></span>
        <div @click='myadr'>
          <span class='type_express'>查看包拯地址</span>
          <i></i>
        </div>
      </div>

      <!-- 弹出包拯地址 -->
      <van-popup position="bottom" v-model="myadrShow">
        <div class="containerAdr f28">
          <div class="title">邮递方式</div>
          <div class="close" @click="myadrShow = false"></div>
          <div class='myadrcontent'>
            <p>收件人： 包拯工作室</p>
            <p>电话： 17526857604</p>
            <p>地址： 天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）</p>
          </div>
          <button class="submit btn-black-round" v-copy="'天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）'">复制地址</button>
        </div>
      </van-popup>


    </div>
</template>

<script>
  export default {
    name: 'order-header',
    data(){
      return  {
        myadrShow : false
      }
    },
    props: {
      title: {
        type: String
      },
      model : {
        type : Array,
        default : ()=> []
      }
    },
    computed : {
      chosen(){
        let obj = {};
        this.model.forEach(element => {
          if(element.isDefault){
            obj = element;
          }
        });
        return obj;
      },
      name(){
        if(!this.chosen.contacts){
          if(this.model.length == 0){
            return '新建地址'
          }else {
            return '选择地址'
          }
        }else{
          return this.chosen.contacts;
        }
      }
    },
    methods: {
      copy(){

      },
      myadr(){
        this.myadrShow = true;
      },
      selectAddr () {
        this.$emit('choseAdr')
      }
    }
  }
</script>

<style scoped lang="scss">
.adr_content{
  display: block!important;
}
  .type_express{
    font-size: 26px;
  }
  .new_adr{
    font-size:26px;
    color:#fff; 
    text-align: right;
    img{
      width: 16px;
      margin-left: 56px;
      position: relative;
      top:7px;
    }
  }
  .myadress{
    display: flex;
    justify-content: space-between;
    line-height: 30px;
  }
  .myadrcontent{
    width:670px;
 
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
    border-radius:3px;
    padding-top:50px;
    padding-bottom:50px;
    p{
      font-size: 30px;
      margin-bottom: 20px;
      margin-top:20px;
      margin-left:50px; 
    }
  }
  .order-header{
    width: 100%;
    background: #333;
    h1{
      font-size: 46px;
      line-height: 64px;
      color: #fff;
      font-weight: 500;
      padding: 104px 30px 22px;
      padding-bottom: 32px;
    }
    &>div{
      padding: 0 30px;
      display: flex;
      align-items: center;
      .address{
        flex: none;
        display: flex;
        flex-direction: column;
        // width: 612px;
        max-height: 116px;
        line-height: 36px;
        color: #ccc;
        margin-top: 16px;
        border-bottom: 2px solid #4A4A4A;
        padding-bottom: 30px;
        font-size: 24px;
        // width: 100%;
        margin-right:72px; 
        // margin-right: 50px;
        text-align: right;
      }
      .icon{
        flex: auto;
        display: flex;
        flex-direction: row-reverse;
        padding-top: 20px;
        align-self: flex-start;
        i{
          width: 22px;
          height: 14px;
          background: url("/images/public/arrow-down-white.png") no-repeat center;
          background-size: 22px 14px;
        }
      }
      &.express{
        height: 108px;
        color: #fff;
        justify-content: space-between;
        i{
          width: 40px;
          height: 12px;
          background: url("/images/public/icon-more.png") top center;
          background-size: 40px 12px;
          display: inline-block;
          margin-left: 32px;
        }
      }
    }
  }

  .containerAdr{
    height: 430px;
    padding: 30px;
    width: 100%;
    position: relative;
    padding-bottom:60px;
    .title{
      line-height: 40px;
      margin-bottom: 40px;
    }
    &>span{
      position:absolute;
      right:30px;
      top:80px;
      color:#7ADFDF;
    }
    .addr-container{
      height: 700px;
      overflow-y: scroll;
      ul li{
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
  }
</style>
